import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-words',
  templateUrl: './new-words.component.html',
  styleUrls: ['./new-words.component.scss']
})
export class NewWordsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
